import ArtistNotificationsComponent from './ArtistNotifications.component'

export default ArtistNotificationsComponent